<script setup lang="ts">
import { ref } from 'vue';

import { AppStudioModal, type AppStudioModalControls } from './app-studio-modal';

defineOptions({
    name: 'StModal',
    inheritAttrs: false
});

withDefaults(
    defineProps<{
        hideFooter?: boolean;
        id: string;
        scrollable?: boolean;
    }>(),
    {
        hideFooter: false,
        scrollable: true
    }
);

const modalRef = ref<AppStudioModalControls>();
const openSequence = ref(0);
const emit = defineEmits<{ (event: 'show', value: unknown): void }>();
const show = () => modalRef.value?.show();
const hide = (force = false) => modalRef.value?.hide(force);
const toggle = () => modalRef.value?.toggle();
function onShow(event: unknown): void {
    openSequence.value += 1;
    emit('show', event);
}

defineExpose({ show, hide, toggle });
</script>

<template>
    <AppStudioModal :id="id" ref="modalRef" v-bind="$attrs" :hide-footer="hideFooter" :scrollable="scrollable" @show="onShow">
        <template #title>
            <slot name="title"></slot>
        </template>
        <slot :key="openSequence"></slot>
        <template #footer="slotProps">
            <slot name="footer" v-bind="slotProps"></slot>
        </template>
    </AppStudioModal>
</template>
